<div class="empty-state">
  <div class="empty-state__img">
    <p>No tenés automatizaciones creadas</p>
  </div>
  <button class="empty-state__create-button" [routerLink]="'create'" *ngIf="!isMobile">
    <img src="/assets/icons/plus_rules.svg" alt="plus" />
    Crear Regla
  </button>
</div>
